export default __webpack_public_path__ + "static/media/sunlife.2ba04ad8.png";